/* eslint-disable max-len */

import {defineMessages} from 'react-intl';

export default defineMessages({
	list: {
		id: 'forms.registrationBottomContent.list',
		defaultMessage: '<tag>Lower case letters (a-z)</tag><tag>Upper case letters (A-Z)</tag><tag>Numbers (i.e. 0-9)</tag><tag>Special characters (e.g. !@#$%^&*)</tag>',
	},
	privacyPolicy: {
		id: 'forms.registrationBottomContent.privacyPolicy',
		defaultMessage: 'This registration confirms that I have read and understood this Privacy Policy and that I am at least 18 years old. I give my consent to the collection, processing and transmission of my personal data abroad in compliance with this Privacy Policy:',
	},
	marketing: {
		id: 'forms.registrationBottomContent.marketing',
		defaultMessage: '– for Marketing Purposes (including the receipt of newsletters and information on events, discounts, invitations to events, greetings messages and exclusive promotions regarding Casadei products and services both by automatic means such as e-mail, text messages and social media and by telephone contact on fixed or mobile networks)',
	},
	newsletters: {
		id: 'forms.registrationBottomContent.newsletters',
		defaultMessage: 'Choose the newsletters you want to receive',
	},
	contact: {
		id: 'forms.registrationBottomContent.contact',
		defaultMessage: 'If you want to have your preferences about the communication channels rectified, please write to the following address: privacy@#BRAND_DOMAIN_CONSTANT#',
	},
	dataProfiling: {
		id: 'forms.registrationBottomContent.dataProfiling',
		defaultMessage: '– for Data Profiling activities (analysis of purchase habits for the purpose of receiving personalized offers based on my interests or, in case of combined consent to Marketing activities, the receipt of personalized marketing promotions).',
	},
	disclaimer: {
		id: 'forms.registrationBottomContent.disclaimer',
		defaultMessage: 'I understand that I reserve the right to withdraw my consent at any time by sending an e-mail to privacy@#BRAND_DOMAIN_CONSTANT# and that, given the global reach of this programme, my personal data may also be processed in locations outside my country of residence.',
	},
});
